import React from 'react';
import { FileText } from 'lucide-react';

export const TermsPage = () => {
  return (
    <div className="min-h-screen bg-[#F9FAFB] py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="space-y-6">
          {/* Header */}
          <div className="flex items-center gap-3">
            <div className="bg-[rgba(255,127,50,0.1)] rounded-full p-3">
              <FileText className="w-8 h-8 text-[#FF7F32]" />
            </div>
            <h1 className="text-3xl font-black italic text-[#061970] uppercase tracking-tight">
              Términos y Condiciones de uso
            </h1>
          </div>

          {/* Content */}
          <div className="space-y-6 text-[#4a5565] text-lg leading-relaxed">
            <div>
              <p className="mb-2">
                <span className="font-semibold">Naturaleza del Sitio</span>: Este sitio web es un catálogo digital informativo de la marca MRC (Moto Racing Competition) y no realiza transacciones de venta directa.
              </p>
            </div>

            <div>
              <p className="mb-2">
                <span className="font-semibold">Redireccionamiento a Terceros</span>: Al hacer clic en el botón de compra ("Compra Fácil"), el usuario será dirigido a sitios web de distribuidores oficiales como Elektra o Italika.
              </p>
            </div>

            <div>
              <p className="mb-2">
                <span className="font-semibold">Precios y Disponibilidad</span>: MRC no muestra precios en este sitio para evitar discrepancias. La disponibilidad, el precio final y las opciones de financiamiento son responsabilidad exclusiva del distribuidor final.
              </p>
            </div>

            <div>
              <p className="mb-2">
                <span className="font-semibold">Propiedad Intelectual</span>: El logotipo de MRC, la iconografía técnica y el personaje Max el oso son propiedad exclusiva de la marca y su uso no autorizado está prohibido.
              </p>
            </div>

            <div>
              <p className="mb-2">
                <span className="font-semibold">Responsabilidad del Usuario</span>: Es responsabilidad del conductor elegir la talla correcta y el tipo de casco adecuado para su estilo de manejo (Jet, Integral, Modular o Cross) siguiendo nuestras guías de seguridad.
              </p>
            </div>

            <div>
              <p className="mb-2">
                <span className="font-semibold">Uso de Información</span>: La información técnica y recomendaciones de uso diario se proporcionan para guiar al motociclista mexicano en su seguridad, pero no sustituyen el juicio del conductor en carretera.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
